import * as React from 'react';
import { getFilterType } from './providers';
import { SelectedFilter } from '.';
import { FiltersListButtonGroup, FiltersListValueButton, FiltersListCloseButton } from './editors';
import { FilterChangeLocation } from '../ListingContainer';

interface SelectedFiltersProps {
	selectedFields: SelectedFilter[];
	beginFilterChange?: (selectedFilter: SelectedFilter, location: FilterChangeLocation) => void;
	filterBeingChanged?: SelectedFilter | null;
	onRemoveField?: (selectedFilter: SelectedFilter, stopEditing: boolean) => void;
}

/**
 * Component that displays a list of selected filters and their corresponding values.
 */
class SelectedFilters extends React.Component<SelectedFiltersProps> {
	constructor(props) {
		super(props);
	}

	/**
	 * Uses the provider model to dynamically return friendly value text for a specific component.
	 *
	 * @private
	 * @param {SelectedFilter} selectedFilter
	 * @returns
	 * @memberof SelectedFilters
	 */
	private getValueDisplayByType(selectedFilter: SelectedFilter) {
		return getFilterType(selectedFilter.type).getFriendlyValueForDisplay(
			selectedFilter.value,
			selectedFilter.options,
		);
	}

	public render() {
		return this.props.selectedFields
			.filter((f) => !f.implicit)
			.map((selectedFilter, index) => {
				return (
					<React.Fragment key={index}>
						<FiltersListButtonGroup>
							<FiltersListValueButton
								id={`Filters_${selectedFilter.name}_Popover`}
								ariaExpanded={this.props.filterBeingChanged === selectedFilter}
								ariaHasPopup="dialog"
								onClick={() => {
									if (this.props.beginFilterChange) {
										this.props.beginFilterChange(
											selectedFilter,
											FilterChangeLocation.SelectedFilter,
										);
									}
								}}
							>
								<strong>{selectedFilter.displayName}:</strong>{' '}
								{this.getValueDisplayByType(selectedFilter) || '<Any>'}
							</FiltersListValueButton>
							{!selectedFilter.permanent ? (
								<FiltersListCloseButton
									ariaLabel={`Remove ${selectedFilter.displayName} as a filter`}
									onClick={() => {
										if (this.props.onRemoveField) {
											this.props.onRemoveField(selectedFilter, true);
										}
									}}
								/>
							) : null}
						</FiltersListButtonGroup>
					</React.Fragment>
				);
			});
	}
}

export default SelectedFilters;
